var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignalBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4821 4H13.4821C14.0343 4 14.4821 4.44772 14.4821 5V11C14.4821 11.5523 14.0343 12 13.4821 12H12.4821C11.9298 12 11.4821 11.5523 11.4821 11V5C11.4821 4.44772 11.9298 4 12.4821 4Z",
    fill: "#D1D1D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98206 6H8.98206C9.53434 6 9.98206 6.44772 9.98206 7V11C9.98206 11.5523 9.53434 12 8.98206 12H7.98206C7.42977 12 6.98206 11.5523 6.98206 11V7C6.98206 6.44772 7.42977 6 7.98206 6Z",
    fill: "#D1D1D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48206 7.5H4.48206C5.03434 7.5 5.48206 7.94772 5.48206 8.5V11C5.48206 11.5523 5.03434 12 4.48206 12H3.48206C2.92977 12 2.48206 11.5523 2.48206 11V8.5C2.48206 7.94772 2.92977 7.5 3.48206 7.5Z",
    fill: "#D1D1D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9821 2H17.9821C18.5343 2 18.9821 2.44772 18.9821 3V11C18.9821 11.5523 18.5343 12 17.9821 12H16.9821C16.4298 12 15.9821 11.5523 15.9821 11V3C15.9821 2.44772 16.4298 2 16.9821 2Z",
    fill: "#3C3C43",
    fillOpacity: 0.18
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4821 4H13.4821C14.0343 4 14.4821 4.44772 14.4821 5V11C14.4821 11.5523 14.0343 12 13.4821 12H12.4821C11.9298 12 11.4821 11.5523 11.4821 11V5C11.4821 4.44772 11.9298 4 12.4821 4Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98206 6H8.98206C9.53434 6 9.98206 6.44772 9.98206 7V11C9.98206 11.5523 9.53434 12 8.98206 12H7.98206C7.42977 12 6.98206 11.5523 6.98206 11V7C6.98206 6.44772 7.42977 6 7.98206 6Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48206 7.5H4.48206C5.03434 7.5 5.48206 7.94772 5.48206 8.5V11C5.48206 11.5523 5.03434 12 4.48206 12H3.48206C2.92977 12 2.48206 11.5523 2.48206 11V8.5C2.48206 7.94772 2.92977 7.5 3.48206 7.5Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalBars);
export default __webpack_public_path__ + "static/media/SignalBars.f78b1eac3cedbaf3c2495062b062f2e5.svg";
export { ForwardRef as ReactComponent };